import { Component } from '@angular/core';
import { Routes } from '@angular/router';

import { ConfigService } from '@ph-core/services/config/config.service';

import { authGuard } from './core/route-guards/auth.guard';
import { loginGuard } from './core/route-guards/login.guard';
import { redirectGuard } from './core/route-guards/redirect.guard';

@Component({
  template: '',
})
class MockRouteComponent {}

const application = ConfigService.getEnvironment().application;

export const APP_ROUTES: Routes = [
  { path: '', redirectTo: 'home', pathMatch: 'full' },
  {
    path: application,
    children: [
      {
        path: '',
        redirectTo: '/',
        pathMatch: 'full',
      },
      { path: 'callback', redirectTo: '/callback' },
    ],
  },
  {
    path: 'home',
    loadChildren: () => import('./home/home-routes').then((m) => m.HOME_ROUTES),
    canActivate: [authGuard],
    canActivateChild: [authGuard],
  },
  {
    path: 'internal',
    loadChildren: () => import('./internal/internal-routes').then((m) => m.INTERNAL_ROUTES),
  },
  {
    path: 'login',
    loadComponent: () => import('./login/login.component'),
    canActivate: [loginGuard],
  },
  {
    path: 'callback',
    loadChildren: () => import('./callback/callback-routes').then((m) => m.CALLBACK_ROUTE),
  },
  { path: 'not-found', loadComponent: () => import('./not-found/not-found.component') },
  { path: 'forbidden', loadComponent: () => import('./forbidden/forbidden.component') },
  { path: '**', canActivate: [redirectGuard], component: MockRouteComponent },
];
